import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import GolfCourseIcon from '@material-ui/icons/GolfCourse';
import css from './bfm.css';

class FeedSetup extends React.Component {

  render() {
    const { onShare, onAuthorise, onClose, selectedBank } = this.props;
    const info = [
      <br />, 
      <br />,
      'To complete the Feed setup, you need to authorise the feed,',
      <br />,
      'this includes entering the Banking details.',
      <br />
    ];
    const buttonInfo = [
      <br />,
      <strong>Authorise: </strong>,
      'Use this to continue with Feed Setup',
      <br />,
      <strong>Share: </strong>,
      'Request a client or other User to finalise Authentication',
      <br />,
      <strong>Later: </strong>,
      'Use this to exit, you can complete setup (or Share) at a later time.',
      <br />
    ];

    return (
      <div>
        <DialogTitle id="alert-dialog-title" className={css.textCenter}>
          <GolfCourseIcon />
          {` Complete feed setup?`}
        </DialogTitle>
        <DialogContent className={[css.textCenter, css.borderBottom].join(' ')}>
          <DialogContentText id="alert-dialog-description">
              You've selected,
              <span className={css.cardHeading}>
                <strong>{` '${selectedBank.bankName}'`}</strong>
              </span>
               {info}
              <span className={[css.pt20, css.pb10, css.font14].join(' ')}>
                {buttonInfo}    
              </span>
          </DialogContentText>
        </DialogContent>
       <DialogActions>
          <Button onClick={onClose} variant="outlined" color="primary">
            Later
          </Button>
          <Button onClick={onShare} variant="outlined" color="primary">
            Share
          </Button>
          <Button onClick={onAuthorise} variant="contained" color="primary">
            Authorise
          </Button>
        </DialogActions>
      </div>
    );
  }
}

FeedSetup = reduxForm({
  form: 'feedWizardForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(FeedSetup);

const selector = formValueSelector('feedWizardForm');

FeedSetup = connect(state => {
  const selectedBank = selector(state, 'selectedBank');
  return { selectedBank };
})(FeedSetup);

export default FeedSetup;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/FeedSetup.js